'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsShallowCompare = require('react-addons-shallow-compare');

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _FontStylePicker = require('./FontStylePicker.scss');

var _FontStylePicker2 = _interopRequireDefault(_FontStylePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FontStylePicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FontStylePicker, _Component);

  function FontStylePicker(props) {
    (0, _classCallCheck3.default)(this, FontStylePicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FontStylePicker.__proto__ || (0, _getPrototypeOf2.default)(FontStylePicker)).call(this, props));

    _this._onChange = function (property, newValue, newState) {
      var onChange = _this.props.onChange;

      if (onChange) onChange(property, newValue, newState);
    };

    _this._onClickItem = function (event) {
      var target = event.target;
      var property = target && target.name;
      var newValues = (0, _extends4.default)({}, _this.state, (0, _defineProperty3.default)({}, property, !_this.state[property]));

      _this._onChange(property, newValues[property], newValues);
      _this.setState((0, _extends4.default)({}, newValues));
    };

    _this.state = (0, _extends4.default)({}, props.values);
    return _this;
  }

  (0, _createClass3.default)(FontStylePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.values !== this.props.values) {
        this.setState((0, _extends4.default)({}, nextProps.values));
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx, _cx2, _cx3;

      var _state = this.state,
          bold = _state.bold,
          italic = _state.italic,
          underline = _state.underline;
      var _props = this.props,
          className = _props.className,
          classNameItem = _props.classNameItem,
          classNameItemActive = _props.classNameItemActive,
          classNameBoldItem = _props.classNameBoldItem,
          classNameItalicItem = _props.classNameItalicItem,
          classNameUnderlineItem = _props.classNameUnderlineItem;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, _FontStylePicker2.default.root) },
        (bold !== undefined || null) && _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(classNameItem, classNameBoldItem, _FontStylePicker2.default.item, _FontStylePicker2.default.bold, (_cx = {}, (0, _defineProperty3.default)(_cx, classNameItemActive, classNameItemActive && bold), (0, _defineProperty3.default)(_cx, _FontStylePicker2.default['item--active'], _FontStylePicker2.default['item--active'] && bold), _cx)),
            name: 'bold',
            onClick: this._onClickItem
          },
          'B'
        ),
        (italic !== undefined || null) && _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(classNameItem, classNameItalicItem, _FontStylePicker2.default.item, _FontStylePicker2.default.italic, (_cx2 = {}, (0, _defineProperty3.default)(_cx2, classNameItemActive, classNameItemActive && italic), (0, _defineProperty3.default)(_cx2, _FontStylePicker2.default['item--active'], _FontStylePicker2.default['item--active'] && italic), _cx2)),
            name: 'italic',
            onClick: this._onClickItem
          },
          'I'
        ),
        (underline !== undefined || null) && _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(classNameItem, classNameUnderlineItem, _FontStylePicker2.default.item, _FontStylePicker2.default.underline, (_cx3 = {}, (0, _defineProperty3.default)(_cx3, classNameItemActive, classNameItemActive && underline), (0, _defineProperty3.default)(_cx3, _FontStylePicker2.default['item--active'], _FontStylePicker2.default['item--active'] && underline), _cx3)),
            name: 'underline',
            onClick: this._onClickItem
          },
          'U'
        )
      );
    }
  }]);
  return FontStylePicker;
}(_react.Component), _class.propTypes = {
  values: _react.PropTypes.shape({
    bold: _react.PropTypes.bool,
    italic: _react.PropTypes.bool,
    underline: _react.PropTypes.bool
  }),

  // CALLBACKS
  onChange: _react.PropTypes.func,

  // CLASS NAMES
  className: _react.PropTypes.string,
  classNameItem: _react.PropTypes.string,
  classNameItemActive: _react.PropTypes.string,
  classNameBoldItem: _react.PropTypes.string,
  classNameItalicItem: _react.PropTypes.string,
  classNameUnderlineItem: _react.PropTypes.string
}, _class.defaultProps = {
  values: {
    bold: false,
    italic: false,
    underline: false
  },
  onChange: function onChange() {}
}, _temp);
exports.default = FontStylePicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/FontStylePicker/FontStylePicker.jsx
// module id = 1576
// module chunks = 0